import { render, staticRenderFns } from "./yueke.vue?vue&type=template&id=22a1e322&scoped=true"
var script = {}
import style0 from "./yueke.vue?vue&type=style&index=0&id=22a1e322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a1e322",
  null
  
)

export default component.exports